import { navigateTo } from './../actions/page.action';
import { createReducer, on, Action } from '@ngrx/store';

import { setMenuItems, setBannerComponent } from '../actions/page.action';
import { PageState } from '../models/page.model';

const initialState: PageState = {
  menu_items: [],
  banner_component: null,
};

const pageReducer = createReducer(
  initialState,
  on(setMenuItems, (state, { items }) => {
    return {
      ...state,
      menu_items: items,
      navigateTo: null,
    };
  }),
  on(setBannerComponent, (state, { banner, subtitle }) => {
    return {
      ...state,
      banner_component: banner,
      banner_subtitle: subtitle,
      navigateTo: null,
    };
  }),
  on(navigateTo, (state, { route }) => {
    return {
      ...state,
      navigateTo: route,
    };
  })
);

export function reducer(state: PageState, action: Action) {
  return pageReducer(state, action);
}
